import Repository from '@/services/Repository';
import TokenService from '../helpers/token';

const resource = `${Repository.defaults.tutorSortUrl}/`;
const careResource = `${Repository.defaults.apiURL}`;
const classinResource = `${Repository.defaults.tutorClassin}`;
export default {
  async getListSchedules(params = {}) {
    const response = await Repository.get(`${resource}v2/class-schedule`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getSortClassInfo(id) {
    const response = await Repository.get(`${careResource}/routine-student/sort-class-info?id=${id}`, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getStudentInfo(id) {
    const response = await Repository.get(`${resource}students?studentProductsId=${id}`, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getListTeachers(payload = {}) {
    const response = await Repository.post(`${resource}v2/class/teachers`, payload, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async changeOperator(payload) {
    const response = await Repository.post(`${resource}assignment-department/assign-to-operator`, payload, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async storeClass2(payload = {}) {
    const response = await Repository.post(`${resource}v2/classroom`, payload, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async updateCareTag(payload) {
    const response = await Repository.put(`${careResource}/care-tag/update`, payload, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async createClassinClass(payload) {
    const response = await Repository.post(`${classinResource}/class-in/create-course`, payload, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async addMultipleStudent(payload) {
    const response = await Repository.post(`${classinResource}/class-in/add-multiple-student-in-course`, payload, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
};
